
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { User } from 'lucide-react';
import useAuth from '@/hooks/useAuth';
import MobileNavigation from './MobileNavigation';

const NavBarLinks = () => {
  const { user, profile, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  
  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <>
      {/* Desktop Navigation */}
      <div className="hidden md:flex items-center gap-2">
        <Button 
          asChild 
          variant="ghost" 
          size="sm"
          className="hover:bg-peach-orange/10 hover:text-sunset-dark transition-colors duration-200"
        >
          <Link to="/list">All Terraces</Link>
        </Button>
        <Button 
          asChild 
          variant="ghost" 
          size="sm"
          className="hover:bg-peach-orange/10 hover:text-sunset-dark transition-colors duration-200"
        >
          <Link to="/about">About</Link>
        </Button>
        
        {user ? (
          <>
            <Button 
              asChild 
              variant="default" 
              size="sm"
              className="bg-gradient-to-r from-peach-orange to-coral-pink hover:from-peach-orange/90 hover:to-coral-pink/90 text-white transition-all duration-200"
            >
              <Link to="/dashboard" className="flex items-center gap-2">
                <User className="h-4 w-4" />
                <span className="hidden lg:inline">{profile?.name || 'Dashboard'}</span>
                <span className="lg:hidden">Profile</span>
              </Link>
            </Button>
            {isAdmin && (
              <Button 
                asChild 
                variant="outline" 
                size="sm"
                className="border-peach-orange/30 text-peach-orange hover:bg-peach-orange hover:text-white transition-all duration-200"
              >
                <Link to="/admin/dashboard">
                  <span className="hidden lg:inline">Admin</span>
                  <span className="lg:hidden">Admin</span>
                </Link>
              </Button>
            )}
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={handleLogout}
              className="hover:bg-coral-pink/10 hover:text-coral-pink transition-colors duration-200"
            >
              Logout
            </Button>
          </>
        ) : (
          <>
            <Button 
              asChild 
              variant="ghost" 
              size="sm"
              className="hover:bg-peach-orange/10 hover:text-sunset-dark transition-colors duration-200"
            >
              <Link to="/login">Sign In</Link>
            </Button>
            <Button 
              asChild 
              variant="default" 
              size="sm"
              className="bg-gradient-to-r from-peach-orange to-coral-pink hover:from-peach-orange/90 hover:to-coral-pink/90 text-white transition-all duration-200"
            >
              <Link to="/waitlist">Join Waitlist</Link>
            </Button>
          </>
        )}
      </div>
      
      {/* Mobile Navigation */}
      <MobileNavigation />
    </>
  );
};

export default NavBarLinks;
